<template>
  <div class="slider">
    <b-carousel
      :key="sliderId"
      :id="sliderId"
      :interval="interval"
      :controls="controls"
      :indicators="indicators"
      background="#000"
      class="carousel"
      :value="activeSlide"
    >
      <div v-if="link !== ''">
        <router-link v-for="image in imagesF" :key="image" :to="link">
          <b-carousel-slide>
            <b-img-lazy fluid slot="img" :src="image | imageSizing(size)" />
          </b-carousel-slide>
        </router-link>
      </div>
      <div v-else>
        <b-carousel-slide v-for="image in imagesF" :key="image">
          <b-img-lazy fluid slot="img" :src="image | imageSizing(size)" />
        </b-carousel-slide>
      </div>
    </b-carousel>
  </div>
</template>

<script>
export default {
  name: "Slider",
  props: {
    id: {
      type: String,
      default: "0",
    },
    images: {
      type: Array,
      default: function () {
        return [];
      },
    },
    interval: {
      type: Number,
      default: 0,
    },
    sliderId: {
      type: String,
      default: "fts",
    },
    size: {
      type: String,
      default: "medium",
    },
    activeSlide: {
      type: Number,
      default: 0,
    },
    link: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      controls: false,
      indicators: false,
      imagesF: [],
    };
  },
  created: function () {
    this.createUpdate();
  },
  updated: function () {
    this.createUpdate();
  },
  methods: {
    createUpdate() {
      this.imagesF = this.images;
      if (this.imagesF.length > 0) {
        this.controls = this.indicators = this.imagesF.length > 1;
        return;
      }
      this.imagesF = ["/images/inv-generic-" + this.size + ".jpg"];
    },
  },
  filters: {
    imageSizing: function (image, size) {
      if (image === "/images/inv-generic-" + size + ".jpg")
        return "https://db97aqbgbmp5i.cloudfront.net" + image;
      return (
        "https://db97aqbgbmp5i.cloudfront.net/images/inv/" +
        size +
        "/" +
        image
      );
    },
  },
  watch: {
    images: function () {
      this.createUpdate();
    },
  },
};
</script>

<style lang="scss" scoped>
.slider {
  width: 100%;
  padding-top: 56.25%;
  position: relative;

  .carousel {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
}
</style>
